import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

interface IImagePreviewOverlayProps {
  src: string;
  alt?: string;
  onClose: () => void;
  /** Full data-testid for the overlay root */
  testId?: string;
}

/**
 * Lightbox for a single image.
 *
 * Built on the shared Radix dialog rather than a hand-rolled backdrop: that is
 * where Escape handling, the focus trap, `aria-modal` and close-on-outside
 * click come from. A bare `<div onClick>` backdrop has none of them for
 * keyboard users, and the click handler it needs is what typescript:S1082
 * reports.
 */
const ImagePreviewOverlay = ({
  src,
  alt = '',
  onClose,
  testId,
}: IImagePreviewOverlayProps) => (
  <Dialog
    open
    onOpenChange={(open) => {
      if (!open) onClose();
    }}
  >
    <DialogContent
      // The shared content is styled as a card. A lightbox wants the image on
      // its own, so the panel chrome is stripped and only the sizing is kept.
      // With no panel behind it the default close control would inherit the
      // dark foreground over a dark backdrop, hence the white override.
      className="bg-transparent border-0 shadow-none p-0 w-auto max-w-none sm:max-w-none [&_[data-slot=dialog-content-close]]:text-white"
      data-testid={testId}
    >
      {/* Radix requires a title for the accessible name; the image is the content. */}
      <DialogTitle className="sr-only">{alt || 'Image preview'}</DialogTitle>
      <img
        src={src}
        alt={alt}
        className="max-w-[80vw] max-h-[80vh] rounded-lg object-contain shadow-2xl"
      />
    </DialogContent>
  </Dialog>
);

export default ImagePreviewOverlay;
